// @ts-nocheck
/* eslint-disable */
export class ItemID {}
ItemID.GRIMY_RANARR_WEED = 207
ItemID.LIMPWURT_ROOT = 225
ItemID.SNAPE_GRASS = 231
ItemID.WHITE_BERRIES = 239
ItemID.JANGERBERRIES = 247
ItemID.GUAM_LEAF = 249
ItemID.MARRENTILL = 251
ItemID.TARROMIN = 253
ItemID.HARRALANDER = 255
ItemID.RANARR_WEED = 257
ItemID.IRIT_LEAF = 259
ItemID.AVANTOE = 261
ItemID.KWUARM = 263
ItemID.CADANTINE = 265
ItemID.DWARF_WEED = 267
ItemID.TORSTOL = 269
ItemID.CADAVA_BERRIES = 753
ItemID.BATTLESTAFF = 1391
ItemID.MAGIC_LOGS = 1513
ItemID.YEW_LOGS = 1515
ItemID.MAPLE_LOGS = 1517
ItemID.WILLOW_LOGS = 1519
ItemID.OAK_LOGS = 1521
ItemID.WOAD_LEAF = 1793
ItemID.POTATO = 1942
ItemID.REDBERRIES = 1951
ItemID.COOKING_APPLE = 1955
ItemID.ONION = 1957
ItemID.BANANA = 1963
ItemID.CABBAGE = 1965
ItemID.TOMATO = 1982
ItemID.GRAPES = 1987
ItemID.ORANGE = 2108
ItemID.PINEAPPLE = 2114
ItemID.DWELLBERRIES = 2126
ItemID.CAVE_NIGHTSHADE = 2398
ItemID.RED_FLOWERS = 2462
ItemID.LANTADYME = 2481
ItemID.WATCH = 2575
ItemID.TOADFLAX = 2998
ItemID.SNAPDRAGON = 3000
ItemID.POTATO_CACTUS = 3138
ItemID.GOUTWEED = 3261
ItemID.STRAWBERRY = 5504
ItemID.JUTE_FIBRE = 5931
ItemID.CURRY_LEAF = 5970
ItemID.PAPAYA_FRUIT = 5972
ItemID.COCONUT = 5974
ItemID.CALQUAT_FRUIT = 5980
ItemID.WATERMELON = 5982
ItemID.SWEETCORN = 5986
ItemID.HAMMERSTONE_HOPS = 5994
ItemID.ASGARNIAN_HOPS = 5996
ItemID.YANILLIAN_HOPS = 5998
ItemID.KRANDORIAN_HOPS = 6000
ItemID.WILDBLOOD_HOPS = 6002
ItemID.MUSHROOM = 6004
ItemID.BARLEY = 6006
ItemID.MARIGOLDS = 6010
ItemID.NASTURTIUMS = 6012
ItemID.ROSEMARY = 6014
ItemID.CACTUS_SPINE = 6016
ItemID.POISON_IVY_BERRIES = 6018
ItemID.WEEDS = 6055
ItemID.SCARECROW = 6059
ItemID.SPIRIT_TREE = 6063
ItemID.MAHOGANY_LOGS = 6332
ItemID.TEAK_LOGS = 6333
ItemID.REDWOOD_LOGS = 19669
ItemID.GIANT_SEAWEED = 21504
ItemID.OLD_NOTES = 22051
ItemID.DRAGONFRUIT = 22929
ItemID.WHITE_LILY = 22932
ItemID.CRYSTAL_SHARDS = 23866
ItemID.BIRD_HOUSE = 21512
ItemID.OAK_BIRD_HOUSE = 21515
ItemID.WILLOW_BIRD_HOUSE = 21518
ItemID.TEAK_BIRD_HOUSE = 21521
ItemID.MAPLE_BIRD_HOUSE = 22192
ItemID.MAHOGANY_BIRD_HOUSE = 22195
ItemID.YEW_BIRD_HOUSE = 22198
ItemID.MAGIC_BIRD_HOUSE = 22201
ItemID.REDWOOD_BIRD_HOUSE = 22204
ItemID.FEATHER = 314
ItemID.COMPOST_BIN = 3271
ItemID.COMPOST = 6032
ItemID.SUPERCOMPOST = 6034
ItemID.ULTRACOMPOST = 21483
ItemID.ROTTEN_TOMATO = 2518
ItemID['__class'] = 'timetracking.ItemID'
